module.exports = __webpack_public_path__ + "img/sendW.d64ccc94.png";